import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class PeticionesService{
  public loginUrl : string;
  public usuario1 : string;
  public usuario2 :string;
  public usuario3:string;
  public usuario4:string;
  public pass1 : string;
  
  menuRuta: string;

  constructor(


    private _httpClientLogin : HttpClient
  ){
    this.loginUrl = "http://gestorpacientes.devel.itsolutionsspa.cl/api/v1/auth/login/";
    this.usuario1 ="142337169";
    this.usuario2 ="106890099";
    this.usuario3="222222222";
    this.usuario4="111111111";
    this.pass1="pacientes2025";
  }

  getValida(){
    return {
      usuario1:this.usuario1, 
      usuario2:this.usuario2, 
      usuario3:this.usuario3,
      usuario4:this.usuario4,
      pass:this.pass1
    };


  }
  getData(){

  }
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/